import { Orient } from '@src/slide/application/service/snap-line-service/interface/orient.interface';
import React, { Component } from 'react';
import sortBy from 'lodash/sortBy';
import { DoubleArrowLine } from '@src/slide/application/service/snap-line-service/render/components/arrow-line/double-arrow-line';
import { IBaseUIProps } from '@src/slide/application/service/snap-line-service/interface/render.interface';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';

export interface IArrowLineProps extends IBaseUIProps {
    orient: Orient;
    range: [number, number];
    position: number;
    arrowSize: Pick<IRect, 'width' | 'height'>;
}
/**
 * 箭头线
 */
export class ArrowLine extends Component<IArrowLineProps> {
    private defaultColor = '#fe6671';

    public render() {
        const { range, position, orient, scale, strokeWidth } = this.props;
        const sortedRange = sortBy(range);
        const lineLength = sortedRange[1] - sortedRange[0];
        const rect = orient === Orient.HORIZONTAL ? {
            width: lineLength,
            height: strokeWidth,
            left: sortedRange[0],
            top: position - (strokeWidth / 2),
        } : {
            width: strokeWidth,
            height: lineLength,
            left: position - (strokeWidth / 2),
            top: sortedRange[0],
        };

        return <DoubleArrowLine
            arrowSize={this.props.arrowSize}
            lineRect={rect}
            orient={orient}
            color={this.defaultColor}
            scale={scale}
            strokeDash={this.props.strokeDash}
            strokeWidth={strokeWidth}
        />;
    }
}
